import { render, staticRenderFns } from "./DiscernmentPassport.vue?vue&type=template&id=53146d10&scoped=true"
import script from "./DiscernmentPassport.vue?vue&type=script&lang=js"
export * from "./DiscernmentPassport.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentPassport.vue?vue&type=style&index=0&id=53146d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53146d10",
  null
  
)

export default component.exports